import { useState } from 'react';
import { faqItems } from '@/mocks/gua88-site';
import { SectionHead } from './articleUi';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="font-display text-sm uppercase tracking-[0.2em] text-primary-500">Help Center</p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            蹲后续常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700">
            关于本站到底在追什么、内容来源可不可信、新人如何快速补课等疑问，都在这里解答。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqItems.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                  open ? 'border-primary-200' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-950 md:text-[15px]">{f.q}</h3>
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? 'rotate-45 bg-primary-100 text-primary-700' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 pl-14 text-sm leading-relaxed text-foreground-700 md:pl-16">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}